import React from 'react'
import { IoReload } from "react-icons/io5";

export default function Footer() {
    return (
        <React.Fragment>
            <div className=" footer">
                <div className="somelinks">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <ul>
                                    <li>
                                        <a href="/privacypolicy">Privacy Policy</a>
                                    </li>
                                    <li>
                                        <a href="/termsconditions">Terms &amp; Conditions</a>
                                    </li>
                                </ul>
                                <div className="clearfix" />
                            </div>
                        </div>
                    </div>
                </div>
            
            <div className="somelinks2">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 text-center">
                            <strong>@ 2024 https://a-71ajsatta.com All Rights Reserved</strong>
                        </div>
                    </div>
                </div>
            </div>
            <section className="somelinks">
  <div className="container">
    <div className="row">
      <div className="col-md-12 text-center">
        <ul>
          <li>
            <a className='text-center' href='#'>
                <strong>
                  !! DISCLAIMER:- A-71 https://a-71ajsatta.com is a non-commercial website.
                  Viewing This Website Is Your Own Risk, All The Information
                  Shown On Website Is Sponsored And We Warn You That Matka
                  Gambling/Satta May Be Banned Or Illegal In Your Country..., We
                  Are Not Responsible For Any Issues Or Scam..., We Respect All
                  Country Rules/Laws... If You Not Agree With Our Site
                  Disclaimer... Please Quit Our Site Right Now. Thank You.
                </strong>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</section>

            </div>
            <div className="icon-bar">
            <a className="facebook fs-2" onClick={() => window.location.reload()}><IoReload/></a>
        </div>
        </React.Fragment>

    )
}
